import React from "react";

export default function Footer() {
  return (
    <footer className="footer student-footer">
      <p>&copy; {new Date().getFullYear()} Zainematics. All rights reserved.</p>
    </footer>
  );
}
